import type { PBPGetResponse, PBPListResponse } from '@percent/admin-dashboard/services/pbpResponses'
import type {
  CreateInternalServiceProps,
  EditInternalServiceProps,
  GetInternalServicesProps,
  InternalService,
  InternalServiceRoleHolder,
  InternalServiceRoleProps,
  InternalServiceServiceCapabilities,
  InternalServiceWithPermissions,
  RevokeInternalServiceRoleProps
} from './internalServices.types'

const SERVICES_PATH = '/v1/admin/services'

const servicePath = (serviceId: string) => `${SERVICES_PATH}/${encodeURIComponent(serviceId)}`

const rolePath = (serviceId: string, holderId: string) =>
  `${servicePath(serviceId)}/roles/${encodeURIComponent(holderId)}`

export const internalServiceService = ({ percentClient }: InternalServiceServiceCapabilities) => ({
  getServices: (params: GetInternalServicesProps) =>
    percentClient.get<PBPListResponse<InternalServiceWithPermissions>>(SERVICES_PATH, {
      params: { ...params, expand: 'permissions' }
    }),
  getServiceById: ({ id }: { id: string }) =>
    percentClient.get<PBPGetResponse<InternalServiceWithPermissions>>(servicePath(id), {
      params: { expand: 'permissions' }
    }),
  createService: (payload: CreateInternalServiceProps) =>
    percentClient.post<PBPGetResponse<InternalService>>(SERVICES_PATH, payload),
  editService: ({ id, ...payload }: EditInternalServiceProps) =>
    percentClient.patch<PBPGetResponse<InternalService>>(servicePath(id), payload),
  deleteService: ({ id }: { id: string }) => percentClient.delete(servicePath(id)),
  getServiceRoles: ({ serviceId }: { serviceId: string }) =>
    percentClient.get<PBPGetResponse<InternalServiceRoleHolder[]>>(`${servicePath(serviceId)}/roles`),
  grantServiceRole: ({ serviceId, ...payload }: InternalServiceRoleProps) =>
    percentClient.post(`${servicePath(serviceId)}/roles`, payload),
  changeServiceRole: ({ serviceId, holderId, role }: InternalServiceRoleProps) =>
    percentClient.put(rolePath(serviceId, holderId), { role }),
  revokeServiceRole: ({ serviceId, holderId }: RevokeInternalServiceRoleProps) =>
    percentClient.delete(rolePath(serviceId, holderId))
})
